<template>
  <div>
    <HomeHero @open-video="onOpenVideo" />
    <HomeStats />
    <HomeProofLogoCloud />
    <HomePlatformTrio />
    <HomePlatformShowcase />
    <HomeReadySolutions />
    <HomeEngineModules />
    <HomeVisualBuilder />
    <HomeIntegrations />
    <HomeWorkflow />
    <HomeCases />
    <HomePromoTemplates />
    <!--<HomePricingTeaser />-->
    <HomeLeadMagnet />
    <HomeContact />
    <HomeClosingCTA />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useSeo } from '@/composables/useSeo';
import HomeHero from '@/pages/_sections/home/HomeHero.vue';
import HomeStats from '@/pages/_sections/home/HomeStats.vue';
import HomeProofLogoCloud from '@/pages/_sections/home/HomeProofLogoCloud.vue';
import HomePlatformTrio from '@/pages/_sections/home/HomePlatformTrio.vue';
import HomePlatformShowcase from '@/pages/_sections/home/HomePlatformShowcase.vue';
import HomeReadySolutions from '@/pages/_sections/home/HomeReadySolutions.vue';
import HomeEngineModules from '@/pages/_sections/home/HomeEngineModules.vue';
import HomeVisualBuilder from '@/pages/_sections/home/HomeVisualBuilder.vue';
import HomeIntegrations from '@/pages/_sections/home/HomeIntegrations.vue';
import HomeWorkflow from '@/pages/_sections/home/HomeWorkflow.vue';
import HomeCases from '@/pages/_sections/home/HomeCases.vue';
import HomePromoTemplates from '@/pages/_sections/home/HomePromoTemplates.vue';
//import HomePricingTeaser from '@/pages/_sections/home/HomePricingTeaser.vue';
import HomeLeadMagnet from '@/pages/_sections/home/HomeLeadMagnet.vue';
import HomeContact from '@/pages/_sections/home/HomeContact.vue';
import HomeClosingCTA from '@/pages/_sections/home/HomeClosingCTA.vue';

const { t } = useI18n();

useSeo({
  title: t('seo.home.title'),
  description: t('seo.home.description'),
});

function onOpenVideo(): void {
  // Видео-демо подключится в Gen 7 (модалка + плейер). До тех пор no-op.
}
</script>
